"use client";
import { jsx } from "react/jsx-runtime";
import { Drawer } from "@base-ui/react/drawer";
import { forwardRef } from "react";
import { cn } from "../../utils/cn.js";
import { drawerVariants } from "./Drawer.variants.js";
const { description: description } = drawerVariants();
const DrawerDescription_DrawerDescription = /*#__PURE__*/ forwardRef(function({ className, slots, ...props }, ref) {
    return /*#__PURE__*/ jsx(Drawer.Description, {
        ref: ref,
        className: cn(description(), className, slots?.description),
        ...props
    });
});
export { DrawerDescription_DrawerDescription as DrawerDescription };
